import axios from "axios";
import i18next from "i18next";
import { toast } from "react-toastify";
import { LoginRepository } from "../repositories/login";

const API_URL = process.env.REACT_APP_BASE_URL;
const API_MAYCA = process.env.REACT_APP_MAYCA_BASE_URL;
const COMMERCE_API_URL = process.env.REACT_APP_COMMERCE_URL;

export const axiosApi = axios.create({
  baseURL: API_URL,
});

export const maycaApi = axios.create({
  baseURL: API_MAYCA,
});

export const maycaApiWithoutAuth = axios.create({
  baseURL: API_MAYCA,
});

export const commerceApi = axios.create({
  baseURL: COMMERCE_API_URL,
});

const maycaTokenInterceptor = (config) => {
  const loginRepository = new LoginRepository();
  const token = loginRepository.getMaycaTOken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
};

const errorLogInterceptor = async (error) => {
  const statusCode = error.response?.status;
  const url = error.response?.config?.url;

  if (statusCode === 401 && !["/auth/login", "/auth/register"].includes(url)) {
    window.location.href = "/login";
  }
  if (statusCode >= 500) {
    toast.error(i18next.t("Something went wrong"), {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  return Promise.reject(error);
};


maycaApi.interceptors.request.use(maycaTokenInterceptor);
maycaApi.interceptors.response.use(undefined, errorLogInterceptor);
maycaApiWithoutAuth.interceptors.request.use(maycaTokenInterceptor);

